// extracted by mini-css-extract-plugin
export var divider = "_16-0";
export var dividerText = "_16-1";